import { render, staticRenderFns } from "./provincemaillist.vue?vue&type=template&id=52c323ca&scoped=true"
import script from "./provincemaillist.vue?vue&type=script&lang=js"
export * from "./provincemaillist.vue?vue&type=script&lang=js"
import style0 from "./provincemaillist.vue?vue&type=style&index=0&id=52c323ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c323ca",
  null
  
)

export default component.exports